import { useExpertUniversityStore, WsEvents } from "@expert/expert-university";
import { useEffect } from "react";
import { useExpertUniversityWebsocket } from "./useExpertUniversityWebsocket";

export function useExpertUniversity() {
    useExpertUniversityWebsocket();
    const { eventBus: expertUniversitySdkEventBus, sendMessage } = useExpertUniversityStore.getState();
    useEffect(() => {
        const sendAudioPlaybackEvent = expertUniversitySdkEventBus?.on("audio-playback", (event) => {
            sendMessage?.(
                JSON.stringify({
                    event: WsEvents.AUDIO_PLAYBACK,
                    value: event.value,
                    timestamp: new Date().toISOString(),
                }),
            );
        });
        return () => {
            sendAudioPlaybackEvent?.();
        };
    }, [expertUniversitySdkEventBus, sendMessage]);
}
